var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_231",
    "data-name": "Grupo 231",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.766 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_315",
    "data-name": "Rect\\xE1ngulo 315",
    width: 33.766,
    height: 40,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_230",
    "data-name": "Grupo 230",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_620",
    "data-name": "Trazado 620",
    d: "M17.427,0a8.147,8.147,0,0,1,1.19.447,3.594,3.594,0,0,1,1.955,3.469c-.005.167-.021.334-.029.456.805.356,1.611.634,2.339,1.049a12.593,12.593,0,0,1,6.761,11.427c.032,2.238.017,4.478,0,6.717a2.213,2.213,0,0,0,.7,1.707c.765.744,1.52,1.5,2.24,2.287a4.48,4.48,0,0,1-2.289,7.4,5.316,5.316,0,0,1-1.161.116c-2.082.011-4.164.005-6.246.005h-.449a5.65,5.65,0,0,1-2.293,3.86,5.433,5.433,0,0,1-3.518,1.057,5.66,5.66,0,0,1-5.309-4.917h-.4c-2.108,0-4.216,0-6.324,0A4.47,4.47,0,0,1,.009,30.218a4.294,4.294,0,0,1,1.3-2.8c.718-.736,1.431-1.478,2.163-2.2a2.082,2.082,0,0,0,.642-1.573c0-2.551-.11-5.11.049-7.652A12.427,12.427,0,0,1,11.5,5.1c.542-.273,1.126-.46,1.671-.679a8.834,8.834,0,0,1,.081-1.44A3.633,3.633,0,0,1,16.009.1c.109-.031.216-.069.324-.1Zm-.55,32.343c4.073,0,8.146-.005,12.219,0a1.761,1.761,0,0,0,1.783-1.069,1.724,1.724,0,0,0-.479-2.055c-.673-.689-1.339-1.385-2.027-2.059a4.7,4.7,0,0,1-1.462-3.535q.019-3.339,0-6.678a13.7,13.7,0,0,0-.105-1.673,10.028,10.028,0,0,0-19.958,1.55q-.014,3.4,0,6.8a4.71,4.71,0,0,1-1.457,3.538c-.705.693-1.388,1.41-2.082,2.114a1.761,1.761,0,0,0,1.27,3.066q6.149.005,12.3,0M14.151,35.09a2.789,2.789,0,0,0,2.88,2.171,2.742,2.742,0,0,0,2.563-2.171Zm1.8-31.214h1.881c.016-.721-.409-1.178-1.013-1.137a.943.943,0,0,0-.868,1.137",
    transform: "translate(0)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.be30e29de6b12ab19b0df702bb2c3ff7.svg";
export { ForwardRef as ReactComponent };